export const mapViewSubmissionItemToListItem = (input: {
    id: string;
    name: string;
    htmlUrlPath: string;
    views?: string;
    submissions?: string;
}) => {
    const {id, name, htmlUrlPath, views, submissions} = input;

    const viewsString = views ? `${views} ${views === '1' ? 'view' : 'views'}` : '';
    const submissionsString = submissions
        ? `${submissions} ${submissions === '1' ? 'submission' : 'submissions'}`
        : '';

    const subtitle = `${viewsString}${
        viewsString.length && submissionsString.length ? ' | ' : ''
    }${submissionsString}`;

    return {
        id,
        name,
        htmlUrlPath,
        subtitle,
    };
};
